/**
 * WordService — word validation.
 *
 * Loads a word list for O(1) validation via Set.
 * Generic: works with any word list, not hardcoded to English.
 *
 * Stored in game.registry as "wordService".
 */

export class WordService {
  private words: Set<string> = new Set();
  private byLength: Map<number, string[]> = new Map();

  async init(wordsUrl: string = "/data/words.json"): Promise<void> {
    const resp = await fetch(wordsUrl);
    if (!resp.ok) throw new Error(`Failed to load word list: ${resp.status}`);
    const wordArray: string[] = await resp.json();
    this.words = new Set(wordArray);

    // Index by length for seed picking
    for (const w of wordArray) {
      const len = w.length;
      let arr = this.byLength.get(len);
      if (!arr) { arr = []; this.byLength.set(len, arr); }
      arr.push(w);
    }
  }

  /** Get a random word of the given length (uppercase), or null if none exist. */
  randomWordOfLength(len: number): string | null {
    const arr = this.byLength.get(len);
    if (!arr || arr.length === 0) return null;
    return arr[Math.floor(Math.random() * arr.length)].toUpperCase();
  }

  isValid(word: string): boolean {
    return this.words.has(word.toLowerCase());
  }

  get wordCount(): number {
    return this.words.size;
  }

  get ready(): boolean {
    return this.words.size > 0;
  }
}
